<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent width="400">
        <v-card class="mt-3 pa-1">
            <Title title="パスワードの変更">
                <v-spacer />
                <TitleButton
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <v-card-text class="pa-0">
                <v-container>
                    <v-form ref="form">
                        <v-row dense>
                            <v-col cols="12">
                                <v-text-field 
                                    v-model="currentPassword" 
                                    clearable 
                                    label="今のパスワード" 
                                    outlined
                                    type="password"
                                    :rules="[validatorRequire]" />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field 
                                    v-model="newPassword" 
                                    clearable 
                                    label="新しいパスワード" 
                                    outlined
                                    type="password"
                                    :rules="[validatorRequire]" />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" @click="onClickChange">変更</v-btn>
                </v-card-actions>
            </v-card-text>
        </v-card>
        <Confirm ref="confirm" />
    </v-dialog>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import fb from '@/firebase/firebase.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import Confirm from '@/components/tools/ConfirmDialog';
    import firebaseApp from 'firebase/app'
    import crypto from "crypto-js"

    export default {
        components: {
            Title,
            TitleButton,
            Confirm
        },
        data: function () {
            return {
                isView: false,
                currentPassword: "",
                newPassword: "",
                validatorRequire: value => !!value || '必須入力です。',
            }
        },
        methods: {
            onClickChange: function () {
                
                if (!this.$refs.form.validate()) {
                    return
                }

                const self = this
                const fbUser = this.$store.getters["firebaseUser"]

                console.log(fbUser)

                const credential = firebaseApp.auth.EmailAuthProvider.credential(
                    fbUser.email, this.currentPassword
                )

                this.$store.commit("processing", {start:true, message:"パスワードを変更しています…。"})

                fbUser.reauthenticateWithCredential(credential).then(function(){
                    console.log("current password ok")
                    fbUser.updatePassword(self.newPassword).then(function(){
                        self.$store.commit("processing")
                        const localDB = self.$store.getters["localDB"]
                        localDB.users.where("email").equals(fbUser.email).first().then(function(record){
                            if (record != null) {
                                localDB.users.update(
                                    record.id, 
                                    {
                                        password: crypto.AES.encrypt(self.newPassword, fbUser.email).toString()
                                    }
                                )
                            }
                        }).catch(function(error){
                            console.log(error)
                        })

                        self.$refs.confirm.show({
                            title: "パスワード変更",
                            message: "パスワードを変更しました。",
                            buttonYes: "戻る",
                            buttonNo: "",
                            listenerYes: function () {
                                self.isView = false
                                return true
                            },
                        })
                    }).catch(function(error){
                        console.log("password update failed!!", error)
                        self.$store.commit("processing")
                        self.$refs.confirm.show({
                            title: "変更失敗",
                            message: "パスワードの変更でエラーが発生しました。<br/>"+error,
                            buttonYes: "戻る",
                            buttonNo: "",
                        })
                    })
                }).catch(function(error){
                    console.log("current password fail!", error)
                    self.$store.commit("processing")
                    self.$refs.confirm.show({
                        title: "変更不可",
                        message: "パスワードの変更が出来ません。<br/>今のパスワードが間違っている可能性があります。",
                        buttonYes: "戻る",
                        buttonNo: "",
                    })
                })
            },
            /**
             * このダイアログを表示
             */
            show: function () {
                this.currentPassword = ""
                this.newPassword = ""
                this.isView = true
            }
        }
    }
</script>